import React, {useEffect, useState} from "react";
import {css, cx} from "@panda/css";

import {IInfiniteListQuery} from "@pg-design/infinite-list";
import {OFFER_TEST_IDS} from "@pg-mono/test-ids";

import {ApplicationSourceSection} from "../application/utils/form/application_form_source";
import {ColumnList} from "../atoms/ColumnList";
import {ColumnListItem} from "../atoms/ColumnListItem";
import {IOfferBox, OfferBox} from "../offer/components/offer_box/OfferBox";
import {OfferModal} from "../offer/components/offer_modal/OfferModal";
import {reservedGridRowStyle} from "../offer/list/styles/reserved_grid_row_style";
import {showOfferModal} from "../offer/state/offer_modals_slice";
import {IOfferListOffer} from "../offer/types/IOfferListOffer";
import {IOfferModalName} from "../offer/types/OfferModalName";
import {IOfferModalOffer} from "../offer/types/OfferModalOffer";
import {useAppDispatch} from "../store/hooks";
import {useGTMEcommerceOfferListViewTracking} from "../tracking/hooks/use_gtm_ecommerce_offer_list_view_tracking";
import {useUserPreferencesFilters} from "../user/hooks/use_user_preferences_filters";

interface IProps {
    offersNearby: IOfferListOffer[];
    modalQuery: IInfiniteListQuery<IOfferModalOffer>;
    lastElement?: React.JSX.Element;
    trackingMeta: IOfferBox["trackingMeta"];
    isSidebarReserved?: boolean;
}

const FIRST_NEARBY_ELEMENT_ID = "first-nearby-element";
const modalName: IOfferModalName = "extraOfferModal";

export const NearbyOffersPanel = (props: IProps) => {
    const {offersNearby, lastElement, modalQuery, trackingMeta, isSidebarReserved} = props;

    const [minHeight, setMinHeight] = useState(0);

    const dispatch = useAppDispatch();
    const userPreferencesFilters = useUserPreferencesFilters();

    useEffect(() => {
        const firstNearbyElement = document.getElementById(FIRST_NEARBY_ELEMENT_ID);

        if (firstNearbyElement && !minHeight) {
            setMinHeight(firstNearbyElement.offsetHeight);
        }
    }, []);

    const {containerId} = useGTMEcommerceOfferListViewTracking({
        offers: offersNearby,
        listId: trackingMeta.listId,
        listName: trackingMeta.listName,
        useVisibilityTracking: true
    });

    return (
        <>
            <ColumnList className={listStyle} rowClassName={cx(rowStyles, isSidebarReserved && reservedGridRowStyle)} id={containerId} data-id={containerId}>
                {offersNearby.map((offer, index) => (
                    <ColumnListItem
                        key={offer.id}
                        id={index === 0 ? FIRST_NEARBY_ELEMENT_ID : undefined}
                        data-testid={OFFER_TEST_IDS.OFFER_VIEW.NEARBY_OFFERS_TILE}
                    >
                        <OfferBox
                            offer={offer}
                            index={index}
                            onShowOfferDetailsBtnClick={() => {
                                dispatch(showOfferModal({modalName, offerId: offer.id, offer, sourceSection: ApplicationSourceSection.MODAL}));
                            }}
                            trackingMeta={trackingMeta}
                        />
                    </ColumnListItem>
                ))}

                {!!lastElement && (
                    <ColumnListItem key="last" style={{minHeight}}>
                        {lastElement}
                    </ColumnListItem>
                )}
            </ColumnList>

            <OfferModal modalName="extraOfferModal" offersQuery={modalQuery} userPreferencePropertyFilters={userPreferencesFilters} />
        </>
    );
};

const listStyle = css({
    paddingLeft: 0,
    paddingRight: 0
});

const rowStyles = css({
    lg: {
        maxWidth: "100%"
    }
});
import React, {useEffect, useState} from "react";
import {css, cx} from "@panda/css";

import {IInfiniteListQuery} from "@pg-design/infinite-list";
import {OFFER_TEST_IDS} from "@pg-mono/test-ids";

import {ApplicationSourceSection} from "../application/utils/form/application_form_source";
import {ColumnList} from "../atoms/ColumnList";
import {ColumnListItem} from "../atoms/ColumnListItem";
import {IOfferBox, OfferBox} from "../offer/components/offer_box/OfferBox";
import {OfferModal} from "../offer/components/offer_modal/OfferModal";
import {reservedGridRowStyle} from "../offer/list/styles/reserved_grid_row_style";
import {showOfferModal} from "../offer/state/offer_modals_slice";
import {IOfferListOffer} from "../offer/types/IOfferListOffer";
import {IOfferModalName} from "../offer/types/OfferModalName";
import {IOfferModalOffer} from "../offer/types/OfferModalOffer";
import {useAppDispatch} from "../store/hooks";
import {useGTMEcommerceOfferListViewTracking} from "../tracking/hooks/use_gtm_ecommerce_offer_list_view_tracking";
import {useUserPreferencesFilters} from "../user/hooks/use_user_preferences_filters";

interface IProps {
    offersNearby: IOfferListOffer[];
    modalQuery: IInfiniteListQuery<IOfferModalOffer>;
    lastElement?: React.JSX.Element;
    trackingMeta: IOfferBox["trackingMeta"];
    isSidebarReserved?: boolean;
}

const FIRST_NEARBY_ELEMENT_ID = "first-nearby-element";
const modalName: IOfferModalName = "extraOfferModal";

export const NearbyOffersPanel = (props: IProps) => {
    const {offersNearby, lastElement, modalQuery, trackingMeta, isSidebarReserved} = props;

    const [minHeight, setMinHeight] = useState(0);

    const dispatch = useAppDispatch();
    const userPreferencesFilters = useUserPreferencesFilters();

    useEffect(() => {
        const firstNearbyElement = document.getElementById(FIRST_NEARBY_ELEMENT_ID);

        if (firstNearbyElement && !minHeight) {
            setMinHeight(firstNearbyElement.offsetHeight);
        }
    }, []);

    const {containerId} = useGTMEcommerceOfferListViewTracking({
        offers: offersNearby,
        listId: trackingMeta.listId,
        listName: trackingMeta.listName,
        useVisibilityTracking: true
    });

    return (
        <>
            <ColumnList className={listStyle} rowClassName={cx(rowStyles, isSidebarReserved && reservedGridRowStyle)} id={containerId} data-id={containerId}>
                {offersNearby.map((offer, index) => (
                    <ColumnListItem
                        key={offer.id}
                        id={index === 0 ? FIRST_NEARBY_ELEMENT_ID : undefined}
                        data-testid={OFFER_TEST_IDS.OFFER_VIEW.NEARBY_OFFERS_TILE}
                    >
                        <OfferBox
                            offer={offer}
                            index={index}
                            onShowOfferDetailsBtnClick={() => {
                                dispatch(showOfferModal({modalName, offerId: offer.id, offer, sourceSection: ApplicationSourceSection.MODAL}));
                            }}
                            trackingMeta={trackingMeta}
                        />
                    </ColumnListItem>
                ))}

                {!!lastElement && (
                    <ColumnListItem key="last" style={{minHeight}}>
                        {lastElement}
                    </ColumnListItem>
                )}
            </ColumnList>

            <OfferModal modalName="extraOfferModal" offersQuery={modalQuery} userPreferencePropertyFilters={userPreferencesFilters} />
        </>
    );
};

const listStyle = css({
    paddingLeft: 0,
    paddingRight: 0
});

const rowStyles = css({
    lg: {
        maxWidth: "100%"
    }
});
